<template lang="html">
  <div id="company-account-page">

    <section class="placed-backg banner-section" v-bind:style="{ backgroundImage: 'url('+$root.user.usercompany.imageUrlBanner+')' }">
      <div class="inside">
        <h1>{{$root.user.name}}</h1>
      </div>
    </section>

    <section class="main-section">
      <div class="container">
        <div class="row">

          <div class="col-lg-3 col-sidebar">
            <div class="content">

              <div class="box-column-title">EMPRESAS</div>

              <div class="box-company-info">
                <div class="box-image">
                  <div class="img" v-bind:style="{ backgroundImage: 'url('+$root.user.usercompany.imageUrl+')' }"></div>
                </div>

                <div class="box-info">
                  <p class="mb-2">
                    <router-link class="btn-squ-cur-1 outline-aqua" :to="{ name: 'compAccImageLogo' }"><i class="poi"></i> Cambiar logo</router-link>
                  </p>

                  <h4 class="plan" v-if="$root.user.order_plan != null">{{$root.user.order_plan}}</h4>
                  <p class="mb-3">
                    <router-link class="link-change" :to="{ name: 'compAccPlans' }"><i class="fal fa-edit"></i> Cambiar plan</router-link>
                  </p>

                  <h5>{{$root.user.name}}</h5>
                  <h5 class="mt-2 f-w-600">Sector</h5>
                  <h5 v-for="(category,indx) in $root.user.categories" :key="indx">{{category.nombre}}</h5>
                  <h5>{{$root.user.ciudad}}, {{$root.user.estado}}</h5>

                  <p class="mt-4">
                    <router-link class="btn-squ-cur-1" :to="{ name: 'compAccBanner' }">Cambiar cabecera</router-link>
                  </p>
                </div>
              </div>

              <div class="box-account-options">
                <router-link class="btn-acc btn-op1" :to="{ name: 'compAccIndex' }"><span>Perfil de empresa</span></router-link>
                <router-link class="btn-acc btn-op10" :to="{ name: 'compAccBanner' }"><span>Imagen de cabecera</span></router-link>
                <router-link class="btn-acc btn-op2" :to="{ name: 'compAccProfile' }"><span>Perfil de Empresa</span></router-link>
                <router-link class="btn-acc btn-op11" :to="{ name: 'compAccPlans' }"><span>Planes</span></router-link>
                <router-link class="btn-acc btn-op3" :to="{ name: 'compAccPostVacancy' }"><span>Publicar Vacante</span></router-link>
                <router-link class="btn-acc btn-op4" :to="{ name: 'compAccEditVacancies' }" v-bind:class="{ 'router-link-exact-active' : $route.name == 'compAccEditVacancy' }"><span>Editar vacante</span></router-link>
                <router-link class="btn-acc btn-op5" :to="{ name: 'compAccCandidates' }" v-bind:class="{ 'router-link-exact-active' : $route.name == 'compAccCandidates' }"><span>Candidatos que aplicaron</span></router-link>

                <router-link class="btn-acc bg-gray btn-op5" :to="{ name: 'AllCandidates' }" v-bind:class="{ 'router-link-exact-active' : $route.name == 'AllCandidates' }"><span>Todos los candidatos</span></router-link>

                <router-link class="btn-acc btn-op6" :to="{ name: 'compAccSavedProfiles' }"><span>Perfiles guardados</span></router-link>
                <router-link class="btn-acc btn-op7" :to="{ name: 'compAccComments' }"><span>Calificaciones a mi empresa</span></router-link>
                <router-link class="btn-acc btn-op7" :to="{ name: 'compAccCommentsCandidates' }"><span>Calificaciones a candidatos</span></router-link>
                <router-link class="btn-acc btn-op8" :to="{ name: 'compAccMessages' }"><span>Mensajes</span></router-link>
                <router-link class="btn-acc btn-op9" :to="{ name: 'compAccSecurity' }"><span>Seguridad</span></router-link>

                <button class="trans-250 border-0 btn-logout" @click="logout">Salir</button>
              </div>

            </div>
          </div>

          <router-view></router-view>

        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data(){
    return{

    }
  },

  watch:{

  },
  methods:{

      logout(){
        axios.post(tools.url("/logout")).then((response)=>{
            this.$root.user = {};
            this.$root.logged=null;
            this.$root.type_logged='';
            this.$router.push('/');
          }).catch(()=>{});
      },



  },
   mounted() {
      this.$root.auth();
  },
}
</script>
